module.exports = __webpack_public_path__ + "static/media/call-outline.2d7aeb42.svg";